import { NAV_PATHS } from '@modules/common/constants';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { Stack } from '@mui/material';
import { matchPath, useLocation } from 'react-router-dom';
import { DashboardAdditionalDetails } from '../DashboardAdditionalDetails';
import { DashboardDescription } from '../DashboardDescription';
import { DashboardName } from '../DashboardName';
import { DashboardDetailsLoading } from './DashboardDetailsLoading';
import { DashboardEmoji } from './DashboardEmoji';

interface DashboardDetailsProps {
  isReadOnly?: boolean;
  shouldShowAbsoluteTime?: boolean;
  shouldShowFullDescription?: boolean;
}

export const DashboardDetails = ({
  isReadOnly,
  shouldShowAbsoluteTime,
  shouldShowFullDescription,
}: DashboardDetailsProps) => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  const location = useLocation();
  const isNewDashboardPage = matchPath(
    `/${NAV_PATHS.NEW_DASHBOARD}`,
    location.pathname,
  );

  if (!dashboard || (!dashboard.id && !isNewDashboardPage)) {
    return <DashboardDetailsLoading />;
  }

  return (
    <Stack direction="row" spacing={1}>
      <DashboardEmoji dashboard={dashboard} />
      <Stack>
        <DashboardName name={dashboard.title} isReadOnly={isReadOnly} />
        <DashboardAdditionalDetails
          dashboard={dashboard}
          shouldShowAbsoluteTime={shouldShowAbsoluteTime}
        />
        <DashboardDescription
          dashboard={dashboard}
          shouldShowFullDescription={shouldShowFullDescription}
          isReadOnly={isReadOnly}
        />
      </Stack>
    </Stack>
  );
};
